export const filterWaMsgStatus = [
  { name: "sent", text: "sent", color: "white" },
  { name: "delivered", text: "delivered", color: "blue" },
  { name: "read", text: "read", color: "green" },
  { name: "failed", text: "failed", color: "red" },
  { name: null, text: "Other", color: "orange" },
];

export const defaultSearchData = {
  isVerifiedNo: -1,
  waOptIn: -1,
  isBlocked: -1,
  createdBy: "all",
  lastContactedBy: "all",
  name: "",
  phoneNumber: "",
  dateLastContacted: "",
  createdOn: "",
};
